export interface ECommBrand {
    id: number;
    name: string;
    imageUrl: string;
    urlSlug: string;
}

export const emptyEcommBrand: ECommBrand = {
    id: 0,
    name: '',
    imageUrl: '',
    urlSlug: '',
};
